<template>
  <Listbox as="div" v-model="currentStore" class="flex items-center">
    <ListboxLabel class="block text-sm font-medium text-white"></ListboxLabel>
    <div class="relative">
      <ListboxButton
        class="rounded-lg relative cursor-pointer border bg-white py-2 pl-3 text-left hover:bg-gray-200 sm:text-sm sm:w-56 w-72"
      >
        <div class="flex flex-row items-center">
          <UserCircleIcon class="h-6 w-6 text-gray-500" />
          <div class="ml-2 block truncate">
            <span class="block truncate font-medium text-xs pr-6 text-gray-800">
              {{ currentStore.salesChannel }}
            </span>
            <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-1">
              <ChevronDownIcon class="h-5 w-5" style="font-size: 0.5rem" aria-hidden="true" />
            </span>
          </div>
        </div>
      </ListboxButton>

      <transition
        leave-active-class="transition ease-in duration-100"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <ListboxOptions
          class="absolute z-10 mt-1 max-h-60 w-full overflow-auto bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm cursor-pointer"
        >
          <ListboxOption
            as="template"
            v-for="store in storesOptions"
            :key="store.id"
            :value="store"
            v-slot="{ active, selected }"
          >
            <li
              :class="[
                selected ? 'text-white bg-primary' : 'text-gray-500',
                active ? 'bg-gray-200' : '',
                'relative cursor-default select-none py-2 pl-3 pr-9 cursor-pointer',
              ]"
            >
              <span
                :class="[selected ? 'text-white bg-primary' : 'text-gray-500', 'text-xs block truncate cursor-pointer']"
              >
                {{ store.salesChannel }}
              </span>
              <span
                v-if="selected"
                :class="[
                  selected ? 'text-white bg-primary' : 'text-gray-500',
                  active ? 'bg-gray-200' : '',
                  'absolute inset-y-0 right-0 flex items-center pr-4 cursor-pointer',
                ]"
              >
                <CheckIcon class="h-5 w-5" aria-hidden="true" />
              </span>
            </li>
          </ListboxOption>
        </ListboxOptions>
      </transition>
    </div>
  </Listbox>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { CheckIcon, ChevronDownIcon, UserCircleIcon } from "@heroicons/vue/solid";
import { Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions } from "@headlessui/vue";
import { isPresent } from "@/utils/validation";

export default {
  components: {
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    CheckIcon,
    ChevronDownIcon,
    UserCircleIcon,
  },

  computed: {
    ...mapState("store", ["stores", "selectedStoreId"]),
    ...mapGetters("store", ["selectedStore"]),

    storesOptions() {
      return [{ id: 0, salesChannel: "Admin" }, ...this.stores];
    },

    currentStore: {
      get() {
        return this.selectedStore || this.storesOptions[0];
      },

      set(value) {
        if (!isPresent(value)) return this.updateStoreId("");

        this.redirect(value);
      },
    },
  },

  methods: {
    ...mapActions("store", ["updateStoreId", "fetchActiveStores"]),

    redirect(currentStore) {
      if (currentStore.salesChannel === "Admin") {
        this.updateStoreId(currentStore.id);
        this.$router.push("/admin/analytics/general");
      } else if (currentStore.source === "offline") {
        this.updateStoreId(currentStore.id);
        this.$router.push(`/pos`);
      } else {
        this.updateStoreId(currentStore.id);
        this.$router.push(`/platform/products`);
      }
    },
  },

  beforeMount() {
    this.fetchActiveStores();
  },

  mounted() {
    // When path is updated to /, the router redirects to the home page.
    // If the home page is a admin page but a store was selected, here we redirect to the store page.
    if (this.$route.meta.layout === "admin-layout") {
      if (this.currentStore?.id != 0 && this.currentStore?.id != "") {
        this.redirect(this.currentStore);
      }
    }
  },
};
</script>
